import { CONSTANT } from './constants';
import { readLocal, saveLocal } from './localStorageHelper';

export const saveDashboardContext = (s) => saveLocal(`hpr-dashboard-${CONSTANT.version}`, s);
export const getDashboardContext = () => readLocal(`hpr-dashboard-${CONSTANT.version}`, null);
